export const mindshareGameLabelStyle = {
  cursor: "pointer",
  pointerEvents: "auto",
  userSelect: "none",
  fontFamily: '"Jura", sans-serif',
  paintOrder: "stroke",
  stroke: "rgba(0,0,0,0.85)",
  strokeWidth: 2,
  strokeLinejoin: "round",
};

export function selectMindshareTooltipPoint(payload, highlighted, hoverSeriesKey) {
  const candidates = (payload || []).filter(point =>
    point &&
    !String(point.dataKey || "").startsWith("__") &&
    point.value != null &&
    Number.isFinite(Number(point.value)) &&
    (highlighted.size === 0 || highlighted.has(String(point.dataKey)))
  );
  const hovered = candidates.find(point => point.dataKey === hoverSeriesKey);
  if (hovered || highlighted.size === 0) return hovered;
  return candidates.reduce((best, point) =>
    !best || Number(point.value) > Number(best.value) ? point : best, undefined);
}
